/* eslint-disable no-restricted-imports */
import {createRoot, Root} from 'react-dom/client'
import {createElement} from 'react'
import UIGame, {UIGameOptions} from './core/UIGame'
import {flushSync} from 'react-dom'
import {GameClientUserState, GameSettings} from '@colonist/game-base-types'
import {UIGameManager} from '../../../code/client/shared/scripts/ui_game/UIGameManager'
import {GameState} from '@colonist/game-states'

export type {FeedMessageData} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageData'
export {resizeUIGame} from './core/UIGame'
export {createFeedMessageDataForGameLogData} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataLogs'
export {createFeedMessageDataForGameChatData} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataChats'
export {setGlobalGameState} from './core/UIGame'
export {setGlobalFocusLogIndex} from './core/UIGameFeeds/UIGameLog/UIGameLog'
export {setGlobalIsLogVisible} from './core/UIGameFeeds/UIGameLog/UIGameLog'
export {setGlobalIsChatVisible} from './core/UIGameFeeds/UIGameChat/UIGameChat'
export {setGlobalMutePlayer} from './contexts/UIMutePlayerContext'
export {addGlobalSpectatorMessage} from './core/UIGameFeeds/UIGameChat/UIGameChat'
export {CARD_TOOLTIP_LINK_PREFIX} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataLogs'

let reactRoot: Root | null = null

export const renderUIGame = (props: {
    gameManager: UIGameManager
    initialUserStates: GameClientUserState[]
    initialGameState: GameState
    options: UIGameOptions
    gameSettings: GameSettings
}) => {
    const {gameManager} = props
    let container = document.getElementById('ui-game') as HTMLDivElement | null
    if(container && reactRoot) {
        reactRoot.unmount()
        reactRoot = null
    }
    if(!container) {
        container = document.createElement('div')
        container.id = 'ui-game'
        container.style.pointerEvents = 'none'
        container.style.position = 'absolute'
        container.style.top = '50%'
        container.style.transform = 'translate(0, -50%)'
        container.style.left = gameManager.canvasController.app.view.style.left
        container.style.width = gameManager.canvasController.appW + 'px'
        container.style.height = gameManager.canvasController.appH + 'px'
        document.body.appendChild(container)
    }

    reactRoot = createRoot(container)
    // TODO remove flushSync when everything migrated to React
    flushSync(() => {
        reactRoot?.render(createElement(UIGame, props))
    })
}
